import { useCabinetText } from "../../content/CabinetContentContext";
// // import { useEffect, useState } from "react";
// // import { doc, getDoc } from "firebase/firestore";
// // import { db, auth } from "../../firebase";
// // import { subscribeUserInvoices } from "../../services/invoicesService";

// // export default function BusinessInvoices() {
// //   const [pm, setPm] = useState("card");
// //   const [list, setList] = useState([]);

// //   useEffect(() => {
// //     const uid = auth?.currentUser?.uid;
// //     if (!uid) return;

// //     getDoc(doc(db, "users", uid)).then((s) => {
// //       setPm(s.data()?.paymentMethod || "card");
// //     });

// //     const unsub = subscribeUserInvoices(uid, setList);
// //     return () => unsub && unsub();
// //   }, []);

// //   if (pm !== "invoice") return null;
// //   function getViewerHref(fileUrl) {
// //     // 1) основний: пряме посилання
// //     const direct = fileUrl;

// //     // 2) фолбек: viewerng
// //     const viewerNg = `https://drive.google.com/viewerng/viewer?embedded=1&url=${encodeURIComponent(
// //       fileUrl
// //     )}`;

// //     // 3) запасний: gview
// //     const gview = `https://docs.google.com/gview?embedded=1&url=${encodeURIComponent(
// //       fileUrl
// //     )}`;

// //     // За замовчуванням покажемо прямий лінк (найстабільніший)
// //     return { direct, viewerNg, gview };
// //   }

// //   return (
// //     <section style={{ marginTop: 24, marginBottom: 24 }}>
// //       <h2 style={{ fontSize: 22, margin: "0 0 10px" }}>Ваші рахунки</h2>
// //       {list.length === 0 ? (
// //         <div style={{ color: "#666" }}>Поки що рахунків немає.</div>
// //       ) : (
// //         <ul style={{ listStyle: "none", padding: 0, display: "grid", gap: 8 }}>
// //           {list.map((inv) => {
// //             const dateStr = inv.orderDate?.toDate
// //               ? inv.orderDate.toDate().toLocaleDateString()
// //               : new Date(inv.orderDate).toLocaleDateString();
// //             const { direct, viewerNg, gview } = getViewerHref(inv.url);

// //             const viewer = `https://docs.google.com/gview?embedded=1&url=${encodeURIComponent(
// //               inv.url
// //             )}`;

// //             return (
// //               <li
// //                 key={inv.id}
// //                 style={{
// //                   background: "#fffbe6",
// //                   border: "1px solid #f5e6a8",
// //                   borderRadius: 10,
// //                   padding: "10px 12px",
// //                   display: "flex",
// //                   justifyContent: "space-between",
// //                   alignItems: "center",
// //                 }}
// //               >
// //                 <div>
// //                   <b>{dateStr}</b>
// //                   <div style={{ fontSize: 12, color: "#666" }}>
// //                     {inv.fileName}
// //                   </div>
// //                 </div>
// //                 {/* <a
// //                   href={viewer}
// //                   target="_blank"
// //                   rel="noreferrer"
// //                   style={{
// //                     textDecoration: "none",
// //                     background: "#facc15",
// //                     padding: "6px 10px",
// //                     borderRadius: 8,
// //                     color: "#000",
// //                   }}
// //                 >
// //                   Відкрити (PDF)
// //                 </a> */}
// //                 <a
// //                   href={direct}
// //                   target="_blank"
// //                   rel="noopener"
// //                   style={{
// //                     textDecoration: "none",
// //                     background: "#facc15",
// //                     padding: "6px 10px",
// //                     borderRadius: 8,
// //                     color: "#000",
// //                   }}
// //                 >
// //                   Відкрити (PDF)
// //                 </a>
// //               </li>
// //             );
// //           })}
// //         </ul>
// //       )}
// //       <div style={{ fontSize: 12, color: "#666", marginTop: 8 }}>
// //         Рахунки зберігаються протягом 1 року від дати замовлення, після чого
// //         видаляються автоматично.
// //       </div>
// //     </section>
// //   );
// // }
// import { useEffect, useState } from "react";
// import { doc, getDoc } from "firebase/firestore";
// import { db, auth } from "../../firebase";
// import { subscribeUserInvoices } from "../../services/invoicesService";

// // ДОДАНО: для повідомлення адміну через чат
// import { sendMessage } from "../../chat/chatService";
// import UserChat from "../chat/UserChat"; // перевір шлях

// export default function BusinessInvoices() {
//   const [pm, setPm] = useState("card");
//   const [list, setList] = useState([]);
//   const [openChat, setOpenChat] = useState(false);

//   // нормалізуємо старе "card" -> "acquiring"
//   const norm = (m) => (m === "card" ? "acquiring" : m);
//   const label = (m) =>
//     ({ invoice: "Рахунок", acquiring: "Еквайринг" }[norm(m)] || "—");

//   useEffect(() => {
//     const uid = auth?.currentUser?.uid;
//     if (!uid) return;

//     getDoc(doc(db, "users", uid)).then((s) => {
//       setPm(s.data()?.paymentMethod || "card");
//     });

//     const unsub = subscribeUserInvoices(uid, setList);
//     return () => unsub && unsub();
//   }, []);

//   // Кнопка "попросити зміну способу" — відправляємо повідомлення в чат та відкриваємо чат
//   const askChange = async (desired) => {
//     const uid = auth?.currentUser?.uid;
//     if (!uid) return;

//     const pretty = label(desired);
//     const text = `Прошу змінити спосіб оплати на: ${pretty}.`;

//     try {
//       await sendMessage(uid, {
//         text,
//         from: "user",
//         senderId: uid,
//       });
//       // відкриємо чат одразу, щоб юзер бачив, що повідомлення пішло
//       setOpenChat(true);
//     } catch (e) {
//       console.error(e);
//       alert("Не вдалося надіслати повідомлення. Спробуйте ще раз.");
//     }
//   };

//   function getViewerHref(fileUrl) {
//     const direct = fileUrl;
//     const viewerNg = `https://drive.google.com/viewerng/viewer?embedded=1&url=${encodeURIComponent(
//       fileUrl
//     )}`;
//     const gview = `https://docs.google.com/gview?embedded=1&url=${encodeURIComponent(
//       fileUrl
//     )}`;
//     return { direct, viewerNg, gview };
//   }

//   const pmN = norm(pm);

//   return (
//     <section style={{ marginTop: 24, marginBottom: 24 }}>
//       {/* Блок про поточний спосіб оплати + кнопки заявок */}
//       <div
//         style={{
//           padding: 16,
//           borderRadius: 12,
//           border: "1px solid #e5e7eb",
//           background: "#f8fafc",
//           marginBottom: 16,
//         }}
//       >
//         <div style={{ fontWeight: 700, marginBottom: 6 }}>
//           Поточний спосіб оплати: {label(pmN)}
//         </div>
//         <div style={{ fontSize: 14, marginBottom: 8 }}>
//           Заявка на зміну способу оплати:
//         </div>
//         <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
//           <button
//             onClick={() => askChange("invoice")}
//             disabled={pmN === "invoice"}
//             style={{
//               padding: "8px 12px",
//               borderRadius: 0,
//               border: "1px solid #ddd",
//               background: pmN === "invoice" ? "#e5e7eb" : "#f7cb26",
//               cursor: pmN === "invoice" ? "not-allowed" : "pointer",
//             }}
//           >
//             Рахунок
//           </button>
//           <button
//             onClick={() => askChange("acquiring")}
//             disabled={pmN === "acquiring"}
//             style={{
//               padding: "8px 12px",
//               borderRadius: 0,
//               border: "1px solid #ddd",
//               background: pmN === "acquiring" ? "#e5e7eb" : "#f7cb26",
//               cursor: pmN === "acquiring" ? "not-allowed" : "pointer",
//             }}
//           >
//             Еквайринг
//           </button>
//         </div>
//         <div style={{ fontSize: 12, color: "#64748b", marginTop: 8 }}>
//           Ваше повідомлення потрапить адміністратору у чат. Після підтвердження
//           спосіб оплати буде змінено.
//         </div>
//       </div>

//       {/* Якщо еквайринг — лише інформуємо і не показуємо список рахунків */}
//       {pmN !== "invoice" ? (
//         <div style={{ color: "#334155" }}>
//           Для способу “Еквайринг” рахунки не формуються. Оплата здійснюється
//           онлайн, як у роздрібних клієнтів.
//         </div>
//       ) : (
//         <>
//           <h2 style={{ fontSize: 22, margin: "0 0 10px" }}>Ваші рахунки</h2>
//           {list.length === 0 ? (
//             <div style={{ color: "#666" }}>Поки що рахунків немає.</div>
//           ) : (
//             <ul
//               style={{ listStyle: "none", padding: 0, display: "grid", gap: 8 }}
//             >
//               {list.map((inv) => {
//                 const dateStr = inv.orderDate?.toDate
//                   ? inv.orderDate.toDate().toLocaleDateString()
//                   : new Date(inv.orderDate).toLocaleDateString();
//                 const { direct /*, viewerNg, gview*/ } = getViewerHref(inv.url);

//                 return (
//                   <li
//                     key={inv.id}
//                     style={{
//                       background: "#fffbe6",
//                       border: "1px solid #f5e6a8",
//                       borderRadius: 10,
//                       padding: "10px 12px",
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "center",
//                     }}
//                   >
//                     <div>
//                       <b>{dateStr}</b>
//                       <div style={{ fontSize: 12, color: "#666" }}>
//                         {inv.fileName}
//                       </div>
//                     </div>
//                     <a
//                       href={direct}
//                       target="_blank"
//                       rel="noopener"
//                       style={{
//                         textDecoration: "none",
//                         background: "#facc15",
//                         padding: "6px 10px",
//                         borderRadius: 8,
//                         color: "#000",
//                       }}
//                     >
//                       Відкрити (PDF)
//                     </a>
//                   </li>
//                 );
//               })}
//             </ul>
//           )}
//           <div style={{ fontSize: 12, color: "#666", marginTop: 8 }}>
//             Рахунки зберігаються протягом 1 року від дати замовлення, після чого
//             видаляються автоматично.
//           </div>
//         </>
//       )}

//       {/* Вікно чату відкриваємо після відправки заявки або за потреби */}
//       {openChat && (
//         <UserChat
//           uid={auth?.currentUser?.uid}
//           onClose={() => setOpenChat(false)}
//         />
//       )}
//     </section>
//   );
// }
import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db, auth } from "../../firebase";
import { subscribeUserInvoices } from "../../services/invoicesService";
import { sendMessage } from "../../chat/chatService";
import UserChat from "../chat/UserChat";

function normPaymentMethod(method) {
  return method === "card" ? "acquiring" : method;
}

function getPaymentLabel(method) {
  return (
    {
      invoice: "Рахунок",
      acquiring: "Еквайринг",
    }[normPaymentMethod(method)] || "—"
  );
}

function formatDate(orderDate) {
  try {
    if (orderDate?.toDate) {
      return orderDate.toDate().toLocaleDateString("uk-UA");
    }

    if (orderDate) {
      return new Date(orderDate).toLocaleDateString("uk-UA");
    }

    return "Без дати";
  } catch (error) {
    console.error("Помилка форматування дати:", error);
    return "Без дати";
  }
}

function getInvoiceUrl(inv = {}) {
  return (
    inv?.url ||
    inv?.invoiceUrl ||
    inv?.invoiceMeta?.invoiceUrl ||
    inv?.invoice?.invoiceUrl ||
    ""
  );
}

function getInvoiceName(inv = {}) {
  return inv?.fileName || inv?.invoiceNumber || inv?.name || "Файл без назви";
}

function triggerFileOpen(url) {
  if (!url) return;

  const link = document.createElement("a");
  link.href = url;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export default function BusinessInvoices() {
  const t = useCabinetText("invoices");
  const [pm, setPm] = useState("card");
  const [list, setList] = useState([]);
  const [openChat, setOpenChat] = useState(false);

  useEffect(() => {
    const uid = auth?.currentUser?.uid;
    if (!uid) return;

    getDoc(doc(db, "users", uid))
      .then((snapshot) => {
        setPm(snapshot.data()?.paymentMethod || "card");
      })
      .catch((error) => {
        console.error("Помилка отримання способу оплати:", error);
      });

    const unsub = subscribeUserInvoices(uid, (items) => {
      setList(Array.isArray(items) ? items : []);
    });

    return () => {
      if (typeof unsub === "function") unsub();
    };
  }, []);

  const askChange = async (desired) => {
    const uid = auth?.currentUser?.uid;
    if (!uid) return;

    const pretty = getPaymentLabel(desired);
    const text = `Прошу змінити спосіб оплати на: ${pretty}.`;

    try {
      await sendMessage(uid, {
        text,
        from: "user",
        senderId: uid,
      });

      setOpenChat(true);
    } catch (error) {
      console.error("Помилка надсилання повідомлення:", error);
      alert(t("text001"));
    }
  };

  const pmN = normPaymentMethod(pm);

  return (
    <section style={{ marginTop: 24, marginBottom: 24 }}>
      <div
        style={{
          padding: 16,
          borderRadius: 12,
          border: "1px solid #e5e7eb",
          background: "#f8fafc",
          marginBottom: 16,
        }}
      >
        <div style={{ fontWeight: 700, marginBottom: 6 }}>{t("text002")}{getPaymentLabel(pmN)}
        </div>

        <div style={{ fontSize: 14, marginBottom: 8 }}>{t("text003")}</div>

        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <button
            type="button"
            onClick={() => askChange("invoice")}
            disabled={pmN === "invoice"}
            style={{
              padding: "8px 12px",
              borderRadius: 0,
              border: "1px solid #ddd",
              background: pmN === "invoice" ? "#e5e7eb" : "#f7cb26",
              cursor: pmN === "invoice" ? "not-allowed" : "pointer",
            }}
          >{t("text004")}</button>

          <button
            type="button"
            onClick={() => askChange("acquiring")}
            disabled={pmN === "acquiring"}
            style={{
              padding: "8px 12px",
              borderRadius: 0,
              border: "1px solid #ddd",
              background: pmN === "acquiring" ? "#e5e7eb" : "#f7cb26",
              cursor: pmN === "acquiring" ? "not-allowed" : "pointer",
            }}
          >{t("text005")}</button>
        </div>

        <div style={{ fontSize: 12, color: "#64748b", marginTop: 8 }}>{t("text006")}</div>
      </div>

      {pmN !== "invoice" ? (
        <div style={{ color: "#334155" }}>{t("text007")}</div>
      ) : (
        <>
          <h2 style={{ fontSize: 22, margin: "0 0 10px" }}>{t("text008")}</h2>

          {list.length === 0 ? (
            <div style={{ color: "#666" }}>{t("text009")}</div>
          ) : (
            <ul
              style={{
                listStyle: "none",
                padding: 0,
                display: "grid",
                gap: 8,
              }}
            >
              {list.map((inv) => {
                const dateStr = formatDate(inv.orderDate);
                const invoiceUrl = getInvoiceUrl(inv);
                const invoiceName = getInvoiceName(inv);

                return (
                  <li
                    key={inv.id}
                    style={{
                      background: "#fffbe6",
                      border: "1px solid #f5e6a8",
                      borderRadius: 10,
                      padding: "10px 12px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 12,
                      flexWrap: "wrap",
                    }}
                  >
                    <div>
                      <b>{dateStr}</b>
                      <div style={{ fontSize: 12, color: "#666" }}>
                        {invoiceName}
                      </div>
                    </div>

                    {invoiceUrl ? (
                      <button
                        type="button"
                        onClick={() => triggerFileOpen(invoiceUrl)}
                        style={{
                          textDecoration: "none",
                          background: "#facc15",
                          padding: "6px 10px",
                          borderRadius: 8,
                          color: "#000",
                          whiteSpace: "nowrap",
                          fontWeight: 600,
                          display: "inline-block",
                          border: "none",
                          cursor: "pointer",
                        }}
                      >{t("text010")}</button>
                    ) : (
                      <span
                        style={{
                          background: "#e5e7eb",
                          padding: "6px 10px",
                          borderRadius: 8,
                          color: "#475569",
                          whiteSpace: "nowrap",
                          fontWeight: 600,
                          display: "inline-block",
                        }}
                      >{t("text011")}</span>
                    )}
                  </li>
                );
              })}
            </ul>
          )}

          <div style={{ fontSize: 12, color: "#666", marginTop: 8 }}>{t("text012")}</div>
        </>
      )}

      {openChat && (
        <UserChat
          uid={auth?.currentUser?.uid}
          onClose={() => setOpenChat(false)}
        />
      )}
    </section>
  );
}
